export default __webpack_public_path__ + "static/media/Child Friendly GP Award Criteria Letter of 8Mar19.ffebcd84.pdf";